class ProductStitcher extends HTMLElement {
    constructor() {
      super();
      
    }
  
    connectedCallback() {
        this.init();
    }

    init() {
        this.lpFeaturedProduct = document.querySelector("[js-lp-featured-product]")
        this.stitcherItems = this.querySelectorAll("[js-stitcher-item]");
        this.stitcherItems.forEach(stitcherItem => stitcherItem.addEventListener("click", this.handleAjax.bind(this)));
    }

    handleAjax(evt) {
        evt.preventDefault();

        this.lpFeaturedProduct.classList.add('is-loading');
        const handle = evt.currentTarget.getAttribute("data-product-handle");
        const url = `/products/${handle}?section_id=lp-featured-product`;
  
        fetch(url)
          .then((res) => res.text())
          .then((html) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");
            const ajaxLPFeaturedProduct = doc.querySelector("[js-lp-featured-product]");
    
            if (ajaxLPFeaturedProduct) {
                this.lpFeaturedProduct.innerHTML = ajaxLPFeaturedProduct.innerHTML;

                initRtxPDP()
                document.dispatchEvent(new CustomEvent("accordion:init"));
                this.lpFeaturedProduct.classList.remove('is-loading');
            }
          })
          .catch((err) => {
            this.lpFeaturedProduct.classList.remove('is-loading');
          });
    }
}
  
customElements.define("product-stitcher", ProductStitcher);
  